import {lazy} from "react";

export const AutoTrackingGroupsLazy = lazy(() => import('./AutoTrackingGroups'))